/**
 * 首页-管模块
 */
import { request } from 'hxhy-axios'
import { apiList as api } from './apiList'

// 获取角色看板的用户菜单以及权限
export function getUserMenuPermission() {
  return request({
    url: api.indexGuan.dataReport.dataView,
    method: 'get',
  })
}

// 查询课堂报告列表
export function getLessonList(data) {
  return request({
    url: api.indexGuan.getLessonList,
    method: 'post',
    data,
  })
}

/**
 * 获取学校列表信息
 */
export function getSchoolList(data) {
  return request({
    url: api.indexGuan.dataReport.school,
    method: 'get',
    params: data,
  })
}
/**
 * 获取学校或者年级
 */
export function getSchoolOrGrade(data) {
  return request({
    url: api.indexGuan.dataReport.schoolOrGrade,
    method: 'post',
    data: data,
  })
}
/**
 * 获取校长模式总体概览
 */
export function getRectorOverviewPanelData(data) {
  return request({
    url: api.indexGuan.dataReport.rectorOverview,
    method: 'get',
    params: data,
  })
}

/**
 * 获取主任模式总体概览
 */
export function getDirectorOverviewPanelData(data) {
  return request({
    url: api.indexGuan.dataReport.directorOverview,
    method: 'get',
    params: data,
  })
}

/**
 * 获取校长模式本周课堂
 */
export function getRectorGetWeekStatic(data) {
  return request({
    url: api.indexGuan.dataReport.rectorGetWeekStatic,
    method: 'get',
    params: data,
  })
}

/**
 * 获取主任模式本周课堂
 */
export function getDirectorGetWeekStatic(data) {
  return request({
    url: api.indexGuan.dataReport.directorGetWeekStatic,
    method: 'get',
    params: data,
  })
}

/**
 * 获取校长模式年级课堂组织情况
 */

export function getRectorGradeClassroom(data) {
  return request({
    url: api.indexGuan.dataReport.rectorGradeClassroomWeekStatic,
    method: 'get',
    params: data,
  })
}

/**
 * 获取主任模式年级课堂组织情况
 */

export function getDirectorGradeClassroom(data) {
  return request({
    url: api.indexGuan.dataReport.directorGradeClassroomWeekStatic,
    method: 'get',
    params: data,
  })
}

/**
 * 获取校长模式对比分析-按周期
 */
export function getRectorPerCycle(data) {
  return request({
    url: api.indexGuan.dataReport.rectorPerCycle,
    method: 'get',
    params: data,
  })
}

/**
 * 获取校长模式对比分析-按学科
 */
export function getRectorBySubject(data) {
  return request({
    url: api.indexGuan.dataReport.rectorBySubject,
    method: 'get',
    params: data,
  })
}
/**
 * 获取校长模式对比分析-按年级
 */
export function getRectorByGrade(data) {
  return request({
    url: api.indexGuan.dataReport.rectorByGrade,
    method: 'get',
    params: data,
  })
}

/**
 * 获取校长模式教师授课详情
 */
export function getRectorDataSheet(data) {
  return request({
    url: api.indexGuan.dataReport.rectorDataSheet,
    method: 'get',
    params: data,
  })
}

/**
 * 获取时间周期下拉框
 */

export function getTimeRecotorPeriod(cycleType) {
  return request({
    url: api.indexGuan.dataReport.rectorGetCycles + cycleType,
    method: 'get',
  })
}

/**
 * 年级下拉框-校长
 */

export function getGradeRecotor(data) {
  return request({
    url: api.indexGuan.dataReport.rectorGetGrades,
    method: 'get',
    params: data,
  })
}

/**
 * 学科下拉框-校长
 */
export function getSubjectRecotor(data) {
  return request({
    url: api.indexGuan.dataReport.rectorGetDisciplines,
    method: 'get',
    params: data,
  })
}

/**
 * 获取年级主任模式周趋势，各学段，授课次数
 */
export function getDirectorPeriodLessons(data) {
  return request({
    url: api.indexGuan.dataReport.directorPeriodLessons,
    method: 'get',
    params: data,
  })
}

/**
 * 获取年级主任模式周趋势，各教师，授课次数详情
 */
export function getDirectorTeacherLessons(data) {
  return request({
    url: api.indexGuan.dataReport.directorTeacherLessons,
    method: 'get',
    params: data,
  })
}

/**
 * 获取年级主任模式周趋势，各班级，授课次数详情
 */
export function getDirectorClassLessons(data) {
  return request({
    url: api.indexGuan.dataReport.directorClassLessons,
    method: 'get',
    params: data,
  })
}

/**
 * 获取年级主任模式教师授课详情
 */
export function getDrectorDataSheet(data) {
  return request({
    url: api.indexGuan.dataReport.directorDataSheet,
    method: 'get',
    params: data,
  })
}

/**
 * 时间周期-主任
 */
export function getTimeDirectorPeriod(cycleType) {
  return request({
    url: api.indexGuan.dataReport.directorGetCycles + cycleType,
    method: 'get',
  })
}

/**
 * 年级下拉框-主任
 */
export function getGradeDirector(data) {
  return request({
    url: api.indexGuan.dataReport.directorGetGrades,
    method: 'get',
    params: data,
  })
}

/**
 * 学科下拉框-主任
 */
export function getSubjectDirector(data) {
  return request({
    url: api.indexGuan.dataReport.directorGetDisciplines,
    method: 'get',
    params: data,
  })
}
/**
 * 本月课堂
 */
export function getThisMonthClassroom(data) {
  return request({
    url: api.indexGuan.dataReport.getMonthStatic,
    method: 'get',
    params: data,
  })
}

/**
 * 本月课堂作品提交数据统计
 */
export function getThisMonthClassroomWork(data) {
  return request({
    url: api.indexGuan.dataReport.submissionDataStatistics,
    method: 'get',
    params: data,
  })
}

/**
 * 本月课堂总体概览
 */
export function getThisMonthClassroomOverview(data) {
  return request({
    url: api.indexGuan.dataReport.teacherOverview,
    method: 'get',
    params: data,
  })
}

/**
 * 参与展示率
 */
export function getParticipationRate(data) {
  return request({
    url: api.indexGuan.dataReport.participationRate,
    method: 'get',
    params: data,
  })
}

/**
 * 获赞数-课堂成果提交数
 */
export function getPraiseCount(data) {
  return request({
    url: api.indexGuan.dataReport.teacherLessons,
    method: 'get',
    params: data,
  })
}

/**
 * 互动与参与
 */
export function getInteractionAndParticipation(data) {
  return request({
    url: api.indexGuan.dataReport.interactionAndParticipation,
    method: 'get',
    params: data,
  })
}

/**
 * 学习成果与质量
 */
export function getLearningResultsAndQuality(data) {
  return request({
    url: api.indexGuan.dataReport.learningAndQuality,
    method: 'get',
    params: data,
  })
}

/**
 * 推送资源利用率
 */
export function getPushResourceUtilization(data) {
  return request({
    url: api.indexGuan.dataReport.pushResourceRate,
    method: 'get',
    params: data,
  })
}

/**
 * 下载资源利用率
 */
export function getDownloadResourceUtilization(data) {
  return request({
    url: api.indexGuan.dataReport.downloadRate,
    method: 'get',
    params: data,
  })
}

/**
 * 教师授课详情-教师
 */
export function getGroupAndMemberDetail(data) {
  return request({
    url: api.indexGuan.dataReport.groupDataSheet,
    method: 'get',
    params: data,
  })
}

/**
 * 时间周期-教师
 */
export function getTimeTeacherPeriod(data) {
  return request({
    url: api.indexGuan.dataReport.teacherGetCycles,
    method: 'get',
  })
}

/**
 * 班级下拉框-教师
 */
export function getClassTeacher(data) {
  return request({
    url: api.indexGuan.dataReport.teacherGetClass,
    method: 'get',
    params: data,
  })
}

/**
 * 小组下拉框
 */
export function getGroupTeacher(data) {
  return request({
    url: api.indexGuan.dataReport.teacherGetGroup,
    method: 'get',
    params: data,
  })
}

/**
 * 学生下拉框-教师
 */
export function getStudentTeacher(data) {
  return request({
    url: api.indexGuan.dataReport.teacherGetStudent,
    method: 'get',
    params: data,
  })
}

/**
 * 学生对比下拉数据
 */
export function getStudentCompare(data) {
  return request({
    url: api.indexGuan.dataReport.learningAndQualitySelect,
    method: 'get',
    params: data,
  })
}

/**
 * 导出校长数据
 */
export function exportPrincipalData(data) {
  return request({
    url: api.indexGuan.dataReport.rectorDataSheetExport,
    method: 'get',
    params: data,
    responseType: 'blob',
  })
}

/**
 * 导出班主任数据
 */
export function exportClassTeacherData(data) {
  return request({
    url: api.indexGuan.dataReport.directorDataSheetExport,
    method: 'get',
    params: data,
    responseType: 'blob',
  })
}

/**
 * 导出教师数据
 */
export function exportTeacherData(data) {
  return request({
    url: api.indexGuan.dataReport.teacherGroupDataSheetExport,
    method: 'get',
    params: data,
    responseType: 'blob',
  })
}
